<template>
    <router-link class="room_tag" :to="link_to">
        <span class="tag" @click="setSearchConditions(new_conditions)">
            <span v-html="display_tag_name"></span>
        </span>
    </router-link>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'
    import Util from '../assets/js/Util'

    export default {
        name: "RoomTag",
        props: {
            tag: {
                type: Object,
                require: true
            }
        },
        computed: {
            ...mapState('search', ["search_conditions"]),
            new_conditions: _this => {
                const conditions = _this.search_conditions;
                const exist_tag = conditions.find(t => t.id === _this.tag.id);
                return !exist_tag ? [...conditions, _this.tag] : conditions;
            },
            link_to: _this => {
                const search_params = new URLSearchParams();
                _this.new_conditions.forEach(t => search_params.append('tags[]', t.name_ja));
                return `/?${search_params.toString()}`;
            },
            display_tag_name: _this => {
                let name = _this.tag.name_ja;
                name = Util.sanitize.encode(name);
                const style = "position: relative; left: -0.15em; letter-spacing: -0.3em;";
                return name.replaceAll('・', `<span style="${style}">・</span>`);
            }
        },
        methods: {
            ...mapMutations('search', ["setSearchConditions"]),
        }
    }
</script>

<style scoped lang="scss">
    .room_tag {
        text-decoration: none;
        .tag{
            display: inline-flex;
            align-items: center;
            padding: 0.4px 8px;
            /*padding: 1.4px 8px 0;*/
            /*height: 20px;*/
            /*line-height: 20px;*/
            font-size: 13px;
            color: #826E67;
            background-color: white;
            /*border: solid 1px #a58d86;*/
            border: solid 1px #cdc5c2;
            border-radius: 5px;
            margin-bottom: 6px;
            white-space: nowrap;
            &:not(last-child) {
                margin-right: 6px;
            }
            &:hover {
                background-color: #fafafa;
                opacity: 0.8;
            }
            span{
                position: relative;
                top: 1px;
                .tiny{
                    letter-spacing: -0.25em;
                }
            }
        }
    }
    @media only screen and (max-width: 639px) {
        .room_tag {
            .tag{
                font-size: 11px;
                padding: 0.4px 8px 0.8px;
                margin-bottom: 3px;
            }
        }
    }
</style>
